const historyContribute = {
	data() {
		return {
			contributeList: []
		}
	},
	mounted() {
		this.getContClsList()
	},
	methods: {
		getContClsList() {
			this.$post('reportApi/queryExamSubjectContributionRate', this.params).then(res => {
				this.contributeList = res.data
			})
		}
	}
}
export default historyContribute
